function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.51472 26.4851C10.1842 27.1546 11.2696 27.1546 11.9391 26.4851L18 20.4242L24.0609 26.4851C24.7304 27.1546 25.8158 27.1546 26.4853 26.4851C27.1547 25.8157 27.1547 24.7302 26.4853 24.0608L20.4244 17.9999L26.4853 11.9389C27.1548 11.2695 27.1548 10.1841 26.4853 9.51458C25.8158 8.84511 24.7304 8.84511 24.0609 9.51458L18 15.5755L11.9391 9.51458C11.2696 8.84511 10.1842 8.84511 9.51472 9.51458C8.84525 10.1841 8.84525 11.2695 9.51472 11.9389L15.5756 17.9999L9.51472 24.0608C8.84525 24.7302 8.84525 25.8157 9.51472 26.4851Z",
  fill: "#222B45"
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 9,
  y: 9,
  width: 18,
  height: 18
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.51472 26.4851C10.1842 27.1546 11.2696 27.1546 11.9391 26.4851L18 20.4242L24.0609 26.4851C24.7304 27.1546 25.8158 27.1546 26.4853 26.4851C27.1547 25.8157 27.1547 24.7302 26.4853 24.0608L20.4244 17.9999L26.4853 11.9389C27.1548 11.2695 27.1548 10.1841 26.4853 9.51458C25.8158 8.84511 24.7304 8.84511 24.0609 9.51458L18 15.5755L11.9391 9.51458C11.2696 8.84511 10.1842 8.84511 9.51472 9.51458C8.84525 10.1841 8.84525 11.2695 9.51472 11.9389L15.5756 17.9999L9.51472 24.0608C8.84525 24.7302 8.84525 25.8157 9.51472 26.4851Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
});

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.64f762179e2fc17ca963285612002742.svg";
export { ForwardRef as ReactComponent };